export const toPennies = v => v * 100;
export const toDollars = v => v / 100;

export const round = (v, decimals = 2) => Number(Math.round(+v + `e${decimals}`) + `e-${decimals}`);

export const format = v => {
  return `$${round(v)}`;
};

export const add = (...values) => {
  return toDollars(
    values.reduce((total, v) => {
      return total + toPennies(v);
    }, 0)
  );
};

export const subtract = (...values) => {
  return toDollars(
    values.reduce((total, v) => {
      return total - toPennies(v);
    }, 0)
  );
};

export const multiply = (...values) => {
  return toDollars(
    values.reduce((total, v) => {
      return total * toPennies(v);
    }, 1)
  );
};

export const divide = (...values) => {
  return toDollars(
    values.reduce((total, v) => {
      return total / toPennies(v);
    }, 1)
  );
};
